'use strict';
module.exports = require('./OrderList.vue');